<template>
  <div>
    <div class="page noScroll">
        <div class="edit-contact-info">
          <router-link to="/Rccl.UserCenter/UserContact/Create">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/add-icon.png" class="edit-contact-info-icon">
              <span class="edit-contact-info-title">添加常用乘客</span>
  <!--            <img src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png" class="edit-contact-info-arrow">-->
          </router-link>
          <div class="privacy-layout">
            <privacy-button @privacy-switch="reload" type="btn-mini" :refresh="refresh"></privacy-button>
          </div>
        </div>
        <!-- 乘客列表 -->
        <div class="contactList scroll-container">
            <div class="contactList-container">
                <div class="item-body" v-for="(item, index) in contactList" :key="item.id">
                    <div class="item-leftCon">
                        <p class="item-name">
                          <span v-if="item.chineseLastName || item.chineseFirstName">{{item.chineseLastName || ''}}{{item.chineseFirstName || ''}}&nbsp;</span>
                          <span>{{item.pinyinLastName + ($store.state.page.isMaskValue ? "": " ") + item.pinyinFirstName}}</span>
                        </p>
                        <p class="item-birthSex">
                            <span>{{item.gender === 'M' ? '男' : '女'}}</span> <span>|</span>
                            <span>{{item.dateOfBirth}}</span><span>|</span>
                            <span v-if="item.passportNum" class="item-IdCardInfo">{{item.passportNum}}</span>
                            <span v-else class="item-addIdCardBtn"><router-link tag="a" :to="`/Rccl.UserCenter/UserContact/Detail/${item.id}`" class="external">补充护照信息</router-link></span>
                        </p>
                    </div>
                    <div class="item-rightCon">
                        <div class="item-editBtn">
                            <router-link tag="a" :to="`/Rccl.UserCenter/UserContact/Detail/${item.id}`" class="external"><img src="https://resource.rcclchina.com.cn/tui2/user_center/list-edit-icon.png"></router-link>
                        </div>
                        <div class="item-deleteBtn" @click="deleteTip(item, index)"><img src="https://resource.rcclchina.com.cn/tui2/user_center/list-delelte-btn2.png"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import api from '@/api'
    const PrivacyButton = () => import('@/components/Common/PrivacyButton')
    export default {
        name: 'ContactList',
        components: {
          PrivacyButton
        },
        data () {
            return {
                userToken: '',
                contactList: [],
                refresh: null
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '常用联系人')
            this.showPage()
        },
        methods: {
            reload() {
              this.showPage();
              this.refresh = new Date().getTime();
            },
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                const userToken = this.$store.state.user.userToken
                if (!userToken && userToken.length == 0) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }
                this.userToken = userToken

                const list = await this.getContact(userToken,1)
                // 过滤掉id=0
                this.contactList = list.filter(item => item.id !== 0)
            },
            async getContact (userName) {
                const {success, data, errMsg} = await api.user.getContactInPersonalCenter(userName)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            async deleteTip (item, index) {
                this.$confirm.show('确定删除该联系人吗？', {
                    confirmCallBack: () => {
                        this.deleteContact(item, index)
                    }
                })
            },
            async deleteContact (item, index) {
                this.$loading.show()
                const {success, errMsg} = await api.user.deleteContact({userName: this.userToken, id: item.id})
                if (!success) {
                    this.$alert.show(errMsg)
                } else {
                    this.contactList.splice(index, 1)
                }
                this.$loading.hide()
            }
        }
    }
</script>

<style scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }

    /**添加联系人**/
    .edit-contact-info{
        position: relative;
        width: 100%;
        height: 50px;
        background-color: white;
        padding: 0 19px;
        margin-top: 50px;
    }

    .edit-contact-info-icon {
        width: 16px;
        position: relative;
        top: 16px;
        margin-right: 5px;
    }

    .edit-contact-info-title {
        
        font-size: 14px;
        color: #4A90E2;
        letter-spacing: 0;
        position: relative;
        top: 12px;
        margin-left: 4.5px;
    }

    .edit-contact-info-arrow {
        width: 7px;
        float: right;
        position: relative;
        top: 19px;
    }


    /**** 常用联系人列表页面****/
    .registerButton {
        background-color:#f0af11;
        color:#000d57;
        font-size:13px;
        padding:12px 0;
        margin:44px 10px 0 10px;
        text-align:center;
        position:relative;
    }
    .noborder{
        border:none !important;
    }
    .page-content{
        margin-top: 10px;
        padding-bottom:5.2rem;
        position:relative;
    }
    nav.home-bar-nav {
        background-color:#061556;
    }
    .contactList {
        padding-bottom: 60px;
    }
    .contactList-menubutton {
        padding:13px 12px;
        border-bottom:1px solid #c1c1c1;
        text-align:center;
    }
    .menubutton-item {
        background-color: #eead11;
        width: 95.6%;
        padding: 7px 0;
        display: inline-block;
        position: relative;
    }
    .hold_link {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
    }
    .menu-visitContactIcon {
        margin-left:2.93%;
    }
    .menubutton-item .addContactIcon {
        width:17px;
        height:17px;
        vertical-align:middle;
    }
    .menubutton-item .visitContactIcon {
        width:21px;
        height:17px;
        vertical-align:middle;
    }
    .menubutton-item span{
        font-size:13px;
        color:#fff;
        margin-left:9px;
        vertical-align:middle;
    }
    .contactList-container {

    }

    .item-body {
        position: relative;
        height: 74px;
        background-color: white;
        margin-bottom: 10px;
        padding: 16px 20px;
    }
    .item-body .item-leftCon {
        float:left;
    }
    .item-body .item-leftCon p{
        margin:0;
    }
    .item-body .item-name{
        font-size: 14px;
        color: #333333;
        font-weight: bold;
    }

    .item-body .item-name span:first-child{
        margin-right: 19px;
    }


    .item-body .item-leftCon .item-birthSex {
        font-size: 12px;
        color: #666;
        letter-spacing: 0;
        margin-top: 6px;
        font-weight: normal;
    }

    .item-body .item-leftCon .item-birthSex span {
        margin-right: 6px;
    }

    .item-body .item-addIdCardBtn a{
        color: #4A90E2;
        text-decoration: underline;
        text-underline-position: under;
    }
    .item-body .item-IdCardInfo {

    }
    .item-body .item-rightCon {
        float:right;
    }

    .item-body .item-editBtn {
        display: inline-block;
        vertical-align: top;
        margin-top: 11px;
        width: 20px;
    }

    .item-deleteBtn {
        display: inline-block;
        vertical-align: top;
        margin-left: 39px;
        width: 19px;
        margin-top: 9px;
    }

    .item-deleteBtn img{
        width: 100%;
    }

    .item-body .item-editBtn img {
        width: 20px;
        height: 20px;
    }
    .privacy-layout {
      font-size: 0;
      line-height: 1;
      float: right;
      padding-top: 0.6rem
    }
</style>
